document.addEventListener('DOMContentLoaded', function () {
  function setDetailsState() {
    const screenWidth = window.innerWidth;

    if (screenWidth >= 750) {
      const detailsElements = document.querySelectorAll('footer details');
      detailsElements.forEach((details) => {
        details.setAttribute('open', '');
      });
    } else {
      const detailsElements = document.querySelectorAll('footer details');
      detailsElements.forEach((details) => {
        details.removeAttribute('open');
      });
    }
  }

  window.addEventListener('load', setDetailsState);
  window.addEventListener('resize', setDetailsState);
});
